import { inject, Injectable } from '@angular/core';
import {
	ApiResponse,
	VehicleGpsTrackingRecordDto,
} from '@splitsecondconnect/ultramarine-shared';
import { Observable } from 'rxjs';

import { CoreApiService } from '../../core/api/core-api.service';

@Injectable({
	providedIn: 'root',
})
export class GpsTrackingService {
	#api = inject(CoreApiService);

	getVehiclesStats(): Observable<ApiResponse<VehicleGpsTrackingRecordDto[]>> {
		return this.#api.get('gps-tracking/vehicles/stats');
	}
}
